
import { defaultMaxVolumeCV, defaultMaxVolumeFV } from '#details/constants'
import { RecordValidationIcon } from '#record/constants'
import { SearchIcon } from '#search/constants'
import { DevSettings, devSettingsType } from '#settings/constants'
import { DevSettingsPanel } from '#settings/dev'
import { useAppSettingsFields } from '#settings/fields'
import { SearchSettingsPanel } from '#settings/search'
import { AppSettings } from '#settings/settings'
import { SystemSettingsPanel } from '#settings/system'
import { ValidationSettingsPanel } from '#settings/validation'
import { useEnv } from 'apprise-frontend-core/env'
import { useBetaTester } from 'apprise-frontend-iam/login/logged'
import { useIAMSettings } from 'apprise-frontend-iam/settings'
import { SettingsModule } from 'apprise-frontend-streams/settings/model'
import { DevOnlyIcon } from 'apprise-ui/utils/icons'
import { AiFillAppstore } from 'react-icons/ai'



export const systemSettingsModule: SettingsModule<AppSettings> = {

    Icon: AiFillAppstore,
    Render: SystemSettingsPanel,
    defaults: {
        dateFormat: 'medium'
    },
    type: 'system',
    name: 'rav.appsettings'
}


export const useValidationSettings = () : SettingsModule<AppSettings> => {

    const env = useEnv()

    return {

        Icon: RecordValidationIcon,
        Render: ValidationSettingsPanel,
        defaults: {
            photosRequired: env.name !== 'development',
            validateIMOChecksum: env.name === 'production',
            minPhotoQuality: 0,
            validatePhotoQuality: true,
            maxVolumeFV: defaultMaxVolumeFV,
            maxVolumeCV: defaultMaxVolumeCV
        },
        // checks the panel's values: Save stays disabled while one is invalid.
        fields: useAppSettingsFields,
        type: 'validation',
        name: 'rav.validationsettings'
    }
}



export const searchSettingsModule: SettingsModule<AppSettings> = {

    Icon: SearchIcon,
    Render: SearchSettingsPanel,
    type: 'search',
    name: 'rav.searchsettings'
}



// outside production for all, in production for beta testers (as dfad), who need the toggle picker there.
// also runs for guests, through useAppSettings: hence the null-safe useBetaTester.
export const useDevSettings = (): SettingsModule<DevSettings> => {

    const env = useEnv()

    const { betaTesters } = useIAMSettings()

    const username = useBetaTester()


    return {

        Icon: DevOnlyIcon,
        name: 'rav.devsettings',
        type: devSettingsType,
        renderIf: env.name !== 'production' || !!betaTesters?.includes(username),
        defaults: {
            autoMatchAndValidate: true
        },
        Render: DevSettingsPanel

    }
}

// export const useExportCompleteSubsciption = (): EventSubscription => {

//     const t = useT()
//     const fb = useFeedback()

//     return  {

//         topic: 'export',
//         onEvent: () => fb.showNotification(t('rav.setting_export_trigger_done'),{ duration: false})
//     }
    
// }